import { useState, useEffect, useCallback } from 'react';
import { setAIPanelWidth } from '../store/ui$';

/**
 * Hook for handling panel resize via drag
 * Used by AIChatPanel and GlobalAIChatPanel
 *
 * @returns {{ isResizing: boolean, handleResizeStart: (e: MouseEvent) => void }}
 */
export function useResizablePanel() {
  const [isResizing, setIsResizing] = useState(false);

  const handleResizeStart = useCallback((e) => {
    e.preventDefault();
    setIsResizing(true);
  }, []);

  useEffect(() => {
    if (!isResizing) return;

    const handleMouseMove = (e) => {
      const newWidth = window.innerWidth - e.clientX;
      setAIPanelWidth(newWidth);
    };

    const handleMouseUp = () => {
      setIsResizing(false);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isResizing]);

  return { isResizing, handleResizeStart };
}

export default useResizablePanel;
